import React, { useState } from 'react';
import "./MyInfoPassword.css";
import { checkUserPasswordEdit } from "../../../api/admin/adminApi"; // ✅ 경로에 맞게 수정 필요

const MyInfoPassword = ({ onClose }) => {
  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ✅ 비밀번호 유효성 검사
  const validatePassword = () => {
    if (!newPassword || !confirmPassword) {
      setErrorMessage("모든 칸을 입력해주세요.");
      return false;
    }
    if (newPassword.length < 4) {
      setErrorMessage("비밀번호는 최소 4자 이상이어야 합니다.");
      return false;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage("비밀번호가 일치하지 않습니다.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  // ✅ 비밀번호 변경 API 호출
  const handlePasswordChange = async () => {
    if (!validatePassword()) return;

    try {
      const data = { currentPassword,newPassword };
      const res = await checkUserPasswordEdit(data);
      console.log("비밀번호 변경 결과:", res);
      setSuccessMessage("비밀번호가 성공적으로 변경되었습니다!");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        setSuccessMessage("");
        if (onClose) onClose(); // 비밀번호 창 닫기
      }, 1500);
    } catch (error) {
      console.error("비밀번호 변경 실패:", error);
      setErrorMessage("비밀번호 변경 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className='MyInfoPassword_Container'>
      <div className='MyInfoPassword_TitleBox'>
        비밀번호 변경
      </div>

      {/* 현재 비밀번호 */}
      <div className='MyInfoPassword_NameContainer'>
        <div className='MyInfoPassword_NameBox'>현재 비밀번호</div>
        <input
          type='password'
          className='MyInfoPassword_NameTextFelid'
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="새로운 비밀번호를 입력하세요"
          required
        />
      </div>

      {/* 새 비밀번호 */}
      <div className='MyInfoPassword_NameContainer'>
        <div className='MyInfoPassword_NameBox'>새 비밀번호</div>
        <input
          type='password'
          className='MyInfoPassword_NameTextFelid'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="새로운 비밀번호를 입력하세요"
          required
        />
      </div>

      {/* 새 비밀번호 확인 */}
      <div className='MyInfoPassword_NameContainer'>
        <div className='MyInfoPassword_NameBox'>새 비밀번호 확인</div>
        <input
          type='password'
          className='MyInfoPassword_NameTextFelid'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="비밀번호를 다시 입력하세요"
          required
        />
      </div>

      {/* 메시지 영역 */}
      {errorMessage && (
        <div className='MyInfoPassword_ErrorMessage'>{errorMessage}</div>
      )}
      {successMessage && (
        <div className='MyInfoPassword_SuccessMessage'>{successMessage}</div>
      )}

      {/* 버튼 */}
      <div className='MyInfoPassword_BtnContainer'>
        <div
          className='MyInfoPassword_Btn'
          
          onClick={handlePasswordChange}
        >
          완료
        </div>
        <div
          className='MyInfoPassword_Btn'
         
          onClick={() => {
            if (onClose) onClose();
          }}
        >
          취소
        </div>
      </div>
    </div>
  );
};

export default MyInfoPassword;
